import React, { Component } from "react";
import { connect } from 'react-redux';
import { HashLink as Link } from 'react-router-hash-link';
import { withStyles } from '@material-ui/core/styles';
import { LinkContainer } from "react-router-bootstrap";
import { DropDownMenu2 } from './menus/DropDownMenu2';
import { Navbar, Container, NavDropdown, Nav, Dropdown } from "react-bootstrap";
import getAppConfigParm from '../config/AppConfig';
import { startLogout } from '../actions/auth';
import { BurgerMenuIcon } from './icons/BurgerMenuIcon';
import ImgWithFallback from '../components/image/ImgWithFallback';

//**************************************************************************************
// This is the page header that I copied from server side (SSPageHeader) and refactored it 
// to function on the client. The PageHeader I had before this onbe was renamed to 
// PageHeaderV1.js. The refactored PageHeader allows me to use absolute paths, which was 
// required after migrating the Resource pages, the Faq, and the About-Us page to server side.
// An more appropriate name may have been CSPageHeader (where CS stands for client side).
// May want to consider making that change in the future.
//**************************************************************************************

class PageHeader extends Component {


    componentDidMount() {
        let elem = document.getElementById("navbar");
        document.addEventListener("scroll", () => {
            // if (window.scrollY > 170) {
            /* window.scrollY returns number of pixels scrolled */
            if (window.scrollY > 106 ) {    /* if scrolled more than n pixels (height of navbar) */
                elem.classList.add("is-sticky");
            } else {
                elem.classList.remove("is-sticky");
            }
        });
        let scrollWithOffset = (el, offset) => {
            const elementPosition = el.offsetTop - offset;
            window.scroll({
                top: elementPosition,
                left: 0,
                behavior: "smooth"
            });
        };
        this.setState({ scrollWithOffset });
    }

    // Handlers 
    closeNavbar() {
        if (window.matchMedia("screen and (max-width: 991px)").matches) {
            document.getElementById("collaspe-btn").click();
        }
    }

    logout = (e) => {
        console.log("INSIDE LOGOUT HANDLER")
        // e.preventDefault();
        this.props.startLogout();  // dispatch logout action
    }


    render() {

        let { isAuthenticated } = this.props.auth;
        let siteUrl = getAppConfigParm("siteUrl");
        let blogUrl = getAppConfigParm("blogUrl");
        console.log("This is blogurl from Page Header", blogUrl)

        let resources=  [
            {key: 0, title: "Resources",           selected: false, listname: "resources", path: ""},
            {key: 1, title: "Faq ",                selected: false, listname: "resources", path: `${siteUrl}/resources/faq`},
            {key: 2, title: "Features",            selected: false, listname: "resources", path: `${siteUrl}/resources/features`},
            {key: 3, title: "Type of Events",      selected: false, listname: "resources", path: `${siteUrl}/resources/type-of-events`},
            {key: 4, title: "Helping Hands List",  selected: false, listname: "resources", path: `${siteUrl}/resources/helping-hands`},
            {key: 5, title: "Contribution List",   selected: false, listname: "resources", path: `${siteUrl}/resources/contribution-list`},
            {key: 6, title: "How to Create Event", selected: false, listname: "resources", path: `${siteUrl}/resources/how-to-create-event`},
            {key: 7, title: "How to Pitch In",     selected: false, listname: "resources", path: `${siteUrl}/resources/how-to-pitch-in`},
            {key: 8, title: "Event Planning Tools",    selected: false, listname: "resources", path: `${siteUrl}/resources/event-planning-tools`},
            {key: 9, title: "About Us",            selected: false, listname: "resources", path: `${siteUrl}/resources/about-us`}
        ]

        return (
            <React.Fragment>
            <div style={{height: '10rem'}}>
                <Navbar
                    sticky="top"
                    id="navbar"
                    bg="light"
                    expand="lg"
                    className="navbar navbar-expand-lg navbar-light bg-light"
                    collapseOnSelect={true}
                >
                    <Container>
                      {/*}  <LinkContainer exact to="/">
                            <Navbar.Brand className="navbar-brand">
                        */}
                            <a href={`${siteUrl}`} style={{textDecoration: 'none'}}>
                               {/*  Axo<span>lot</span>  */}
                               <div className="ss2-logo-container">
                                  <div className="rc-flex-container-center">
                                    <ImgWithFallback className="ss2-page-header__logo" src="/images/pitch-in-club-logo.webp" 
                                      fallback="/images/pitch-in-club-logo.jpg" alt="Pitch In Club Logo" >
                                    </ImgWithFallback>
                                    <p className="ss2-page-header__title">PITCH IN <span className="ss2-page-header__title-part2">CLUB</span> </p>
                                  </div>
                               </div>
                            </a>
                      {/*}      </Navbar.Brand>
                        </LinkContainer>
                      */}

                        <Navbar.Toggle  
                            aria-controls="basic-navbar-nav"
                            id="collaspe-btn"
                        > 
                            <BurgerMenuIcon  />
                        </Navbar.Toggle>
{/*                        
                        <div style={{order: '2' }} className="mobile-burger-menu" >
                            <BurgerMenuIcon  />
                        </div>
            */}


                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="ml-auto">
                                <div className="ss2-top-navlinks dd2-flex-container">
                                    <div className="ss2-top-navlink-homexx ss2-top-navlink">
                                        <a href={`${siteUrl}`} className="ss2-page-header-navlink">
                                            <span className="ss2-linktext-size">Home</span>
                                        </a>
                                    </div>
                                    <div className="ss2-top-navlink-resources">
                                        <div className="ss2-dropdown-container">
                                            <DropDownMenu2 title="Resources" list={resources} toggleSelected={this.toggleSelected} 
                                                altHeaderClass="drop-down-header-nb2"  config={{displayHeader: false, upDownArrow: false}} 
                                            />
                                        </div>
                                    </div>
                                {/*    <div className="ss2-top-navlink-faq">
                                        <a href={`${siteUrl}/faq`} className="ss2-page-header-navlink">
                                            <span className="ss2-linktext-size">Faq</span>
                                        </a>
                                     </div>
                                */}
                                    <div className="ss2-top-navlink ss2-page-header-blog-alt">
                                        <a href={`${blogUrl}`} className="ss2-page-header-navlink ">
                                            <span className="ss2-linktext-size">Blog</span>
                                        </a>
                                    </div>
                                    { !isAuthenticated && 
                                        (
                                          <div className="ss2-top-navlink">
                                             <Link to="/login" className="ss2-page-header-navlink">
                                               <div className="ss2-linktext-size">Log In</div>
                                             </Link> 
                                         </div>
                                        ) }
        
                                        { isAuthenticated &&  (
                                            
                                            <div className="ss2-top-navlink">
                                                <Link to="" onClick={this.logout} className="ss2-page-header-navlink">
                                                  <div className="ss2-linktext-size">Log Out</div>
                                                </Link> 
                                            </div>
                                        ) }
        
                                        { !isAuthenticated && 
                                            (
                                            <div className="ss2-top-navlink">
                                                <Link to="/signup" className="ss2-page-header-navlink">
                                                  <div className="ss2-linktext-size">Sign Up</div>
                                                </Link> 
                                            </div>
                                        ) }
                                </div>
                          
                {/*
                            
                                <a  className="rc-ml-1" href={`${siteUrl}`} style={{textDecoration: 'none'}}>
                                    <div className="ss-page-header-navlink" >Home</div>
                                </a>
                                <div className="ss-dropdown-container">
                                    <DropDownMenu2 title="Resources" list={resources} toggleSelected={this.toggleSelected} 
                                        altHeaderClass="drop-down-header-nb2"  config={{displayHeader: false, upDownArrow: false}} 
                                    />
                                </div>
                                <a  className="rc-ml-1" href={`${siteUrl}/faq`} style={{textDecoration: 'none'}}>
                                    <div className="ss-page-header-navlink">Faq</div>
                                </a>
                                <a  className="rc-ml-1" href={`${blogUrl}`} style={{textDecoration: 'none'}}>
                                    <div className="ss-page-header-navlink">Blog</div>
                                </a>
                                { !isAuthenticated && 
                                (
                                    <LinkContainer to="/login">
                                        <Nav.Link>Log In</Nav.Link>
                                    </LinkContainer>                                  
                                ) }

                                { isAuthenticated &&  (
                                    <Nav.Link onClick={this.logout}  style={{textDecoration: 'none'}} >Log out</Nav.Link>
                                ) }

                                { !isAuthenticated && 
                                    (
                                    <LinkContainer to="/signup">
                                        <Nav.Link>Sign Up</Nav.Link>
                                    </LinkContainer>
                                ) }

                                    */}
                            </Nav>
                         </Navbar.Collapse>
                    </Container>
                </Navbar>
              </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
};

const mapDispatchToProps = (dispatch) => ({
    startLogout: () => dispatch(startLogout())
})

// export default NavBarMultiPage;
// export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(NavBarMultiPage));

export default connect(mapStateToProps, mapDispatchToProps)(PageHeader);


   {/*</div>
                                            <div className="ss2-top-navlink-loginout">
                                                <LinkContainer to="/login">
                                                    <Nav.Link>
                                                      <div style={{textTransform: 'capitalize'}}>Log In</div>
                                                    </Nav.Link>
                                                </LinkContainer>          
                                          </div>


                                        <div className="ss2-top-navlink-loginout">
                                                <Nav.Link onClick={this.logout}  style={{textDecoration: 'none', width: '10rem'}} >
                                                  <div style={{textTransform: 'capitalize'}}>Log Out</div>
                                                </Nav.Link>
                                            </div>
                                        
                                        
                                        */}


// WEBPACK FOOTER //
// ./src/components/PageHeader.js